// extracted by mini-css-extract-plugin
module.exports = {"title":"BlogContainer_title__pSut_","searchButton":"BlogContainer_searchButton__lFuev"};